(function () {
  'use strict';

  /* @ngdoc object
   * @name leaveDetailReport
   * @description
   *
   */
  angular
    .module('leaveDetailReport', [
      'ui.router'
    ]);
}());
